import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class FeedbackTimescale extends ApplicationRecord {
  static jsonapiType = "feedback_timescales";

  @Attr() description: string;
}

export default FeedbackTimescale;
